import React, { Component } from "react";
import { connect } from "react-redux";
import { translate } from "react-multi-lang";
import store from "../../../store"
import { Resendotp, set_OTP, postPmOtp } from "../../../actions/accountAction";
import ReactGA from 'react-ga4';
import Validation from "../../hoc/Validation";

class PmOtpVerification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      basePath: window.location.protocol + "//" + window.location.host + "/",
      mobile: "",
      otp: "",
      deviceId: '',
      submitted: false,

      verified: false
    };
  }

  componentWillUnmount() {
    store.dispatch(set_OTP(false));
  }

  componentDidMount() {
    document.title = this.props.t("login.login_otp", { param: "react" });

    const savedMobile = localStorage.getItem("otp_mobile");
    if (savedMobile) {
      this.setState({ mobile: savedMobile });
    }

  }

  handleSubmit = (e) => {
    e.preventDefault();

    const mobile = localStorage.getItem("otp_mobile"); // get from localStorage
    const { otp } = this.state; // user entered otp

    if (!this.state.submitted && mobile && otp) {
      store.dispatch(postPmOtp(mobile, otp));
      this.setState({ submitted: true, verified: true });
    } else {
      this.props.validator.showMessages();
      // this.forceUpdate();
    }
  };

  goToHome = () => {
    window.location.href = this.state.basePath; // ✅ Redirect to home
  };

  resendOtp() {
    const user = {
      mobile: this.state.mobile,
    };
    store.dispatch(Resendotp(user));
  }

  change = (id, e) => {
    let inputType = document.getElementById(id).type;
    if (inputType === "password") {
      document.getElementById(id).type = "text";
      e.target.className = e.target.className.substring(
        0,
        e.target.className.lastIndexOf("-")
      );
    } else {
      document.getElementById(id).type = "password";
      e.target.className += "-slash";
    }
  };

  handleUserInput(e) {
    const name = e.target.name;
    let value = e.target.value;
    this.setState({ [name]: value, submitted: false });
  }

  redirectConditionally = () => {
    if (
      this.props.actionReducer.link &&
      this.props.actionReducer.Loginuser.user_type === "1"
    ) {
      window.location.href =
        this.state.basePath + this.props.actionReducer.link;
      return;
    }

    if (
      this.props.actionReducer.Loginuser &&
      this.props.actionReducer.Loginuser.user_type &&
      (this.props.actionReducer.Loginuser.user_type === "7" ||
        this.props.actionReducer.Loginuser.user_type === "10" ||
        this.props.actionReducer.Loginuser.user_type === "12")
    ) {
      window.location.href = this.state.basePath + "myprofile";
      return;
    }

    if (
      localStorage.getItem("Islogin") &&
      localStorage.getItem("Islogin") === "true"
    ) {
      window.location.href = this.state.basePath + "myprofile";
    }
  };

  render() {
    this.redirectConditionally();
    const { validator } = this.props;

    return (
      <section className="login-form main-content-height item-center">
        <div className="container">
          {this.state.verified ? (
            <div className="text-center p-4">
              <h5 className="text-success rewwr"><b>OTP Verified Successfully 🎉</b></h5>
              <button
                className="btn btn-primary btn-primary2 px-5 py-3 m-0 mt-3"
                onClick={this.goToHome}
              >
                Go to Home Page
              </button>
            </div>
          ) : (
            <div className="col-md-12 col-lg-6 mx-auto cover cover-shadow border-0  p-0">
              <div className="first-click-inst p-3">
                <p>OTP sent to: {this.state.mobile.slice(0, 4) + ' **** ****'}</p>
              </div>

              <div className="panel-body">
                <form className="col-md-12 mx-auto" onSubmit={this.handleSubmit}>
                  <div className="form-group">
                    <div className="row">
                      <div className="col-sm-12 position-relative">
                        <label>
                          {this.props.t("login.code", { param: "react" })}
                        </label>
                        <input
                          onChange={(event) => this.handleUserInput(event)}
                          placeholder={this.props.t("forms.enterOtp", {
                            param: "react",
                          })}
                          type="number"
                          className="form-control form-eye"
                          id="password-otp"
                          name="otp"
                          defaultValue={this.state.otp}
                          maxLength="6"
                          aria-label="Enter OTP"
                        />
                        {validator.message("otp", this.state.otp, "required|numeric|max:6")}

                        <span role="button" tabIndex="0"
                          onClick={(e) => this.change("password-otp", e)}
                          className="input fa fa-fw field-icon toggle-password fa-eye-slash"
                        ></span>

                        <button
                          aria-label='Login with OTP'
                          type="submit"
                          onClick={() => {
                            ReactGA.event({
                              category: 'Auth',
                              action: 'OTP Login',
                              label: 'Login with OTP'
                            });
                          }}
                          disabled={
                            !this.state.otp ||
                            !this.props.validator.fieldValid("otp")
                          }
                          className="btn btn-primary btn-primary2 me-2 my-3"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </section>
    );
  }
}

const mapStateToProps = (store) => {
  return store;
};

export default connect(mapStateToProps)(translate(Validation(PmOtpVerification)));
